import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RequestQuotationModel } from "app/modules/dashboard/models/quotation.models";
import { RelationshipService } from "app/modules/relationship/services/relationship.service";
import { Constants } from "app/shared/constant/constants";
import { ConstantsKey } from "app/shared/constant/constants-keys";
import { PagesList } from "app/shared/constant/page-list";
import { PaymentMode } from "app/shared/constant/payment-mode";
import { WsfxBankDetails } from "app/shared/constant/wsfx-bank-details";
import {
  ReqGetCurrencyMaster,
  SinglePurposeItem,
} from "app/shared/models/shared-models";
import { MasterDataService } from "app/shared/services/master-data.service";
import Stepper from "bs-stepper";
import { ToastrService } from "ngx-toastr";
import {
  CartItemModel,
  RequestAadhaarEsignDetail,
  RequestAadhaarEsignDetailOrder,
  RequestCartMapPayer,
  RequestMapBeneficiaryModel,
} from "../../models/cart.model";
import { Step02Data, StepperDataModel } from "../../models/stepperdata.model";
import { RemittanceService } from "../../services/remittance.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { EsignMode } from "app/shared/constant/esign-mode";
import { UpdateProfileService } from "app/modules/update-profile/services/update-profile.service";
import { UpdateProfileModel } from "app/modules/update-profile/models/update-profile.model";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { CryptoUtils } from "app/shared/utility/crypto.utils";
import { LRSDeclarationRequestModel } from "app/modules/card/models/lrs.model";
import { CardService } from "app/modules/card/services/card.service";
import { DateUtils } from "app/shared/utility/date-utils";
import { NgSelectComponent } from "@ng-select/ng-select/lib/ng-select.component";
import Swal from "sweetalert2";
import { GTMDataLayerService } from "app/shared/services/gtmDataLayer.service";
import { OrderService } from "app/modules/order/services/order.service";
import { RequestOrderFeedbackModel } from "app/modules/order/models/order.model";
import { InputPatterns } from "app/shared/helper/input-patterns";

@Component({
  selector: "app-stepper-3step",
  templateUrl: "./stepper3step.component.html",
  styleUrls: ["../../stepper.scss", "./stepper3step.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class Stepper3StepComponent implements OnInit {
  public contentHeader: string;
  public horizontalWizardStepper: Stepper;
  public showSelfDeclarationPage: boolean = false;
  public selectedSourceofFund: any;
  public showFinancialOptions: boolean = false;
  public selectedPurpose: SinglePurposeItem;
  public countryListItems: any;
  public currencyItems: any;
  public universityListItems: any;
  public selectedCountry: string;
  public selectedUniversity: string;
  public reqCurrencyAmount: any;
  isAddress: boolean = false;
  @ViewChild("kycForm", { static: true }) kycForm: NgForm;
  public inrAmountZero: boolean = false;
  public bankAccountList: any;

  public requestQuotationModel: RequestQuotationModel =
    new RequestQuotationModel();
  public stepperDataModel: StepperDataModel = new StepperDataModel();
  public quotationRequest = new RequestQuotationModel();
  public quotationResponse: any;

  public currentStep: string;

  public sourceofFundItems = Constants.sourceOfFundsItemList;
  public financialInstitutionItem: any;
  public selectedfinancialInstitution: any;
  public selectedInstitution: any;
  public instituteName: any;
  public isPdf: boolean;
  public isImage: boolean;

  public showLoader: boolean = false;
  public showStepper: boolean = true;

  public documentListResponse: any;
  public transactionDocListAwaiting: any;
  public transactionDocListUploaded: any;
  public reqGetCurrencyMaster: ReqGetCurrencyMaster =
    new ReqGetCurrencyMaster();
  @ViewChild("EditCardModal") EditCardModal: TemplateRef<any>;

  public modalReference: any;
  public documentUrl: any;
  public documentTitle: any;
  public navigateToFourthStep: boolean = false;
  public bankAccountId: any;

  public activeCartModelStep: any;
  public paymentMode: any;
  public paymentInstruction: any;

  public accountName = WsfxBankDetails.ACCOUNT_NAME;
  public bankName = WsfxBankDetails.BANK_NAME;
  public accountNo = WsfxBankDetails.ACCOUNT_NUMBER;
  public bankIFSC = WsfxBankDetails.BANK_IFSC;
  public bankBranch = WsfxBankDetails.BANK_BRANCH;
  public showAddBankForm: boolean = false;
  public ALLOW_NEFT_PAYMENT = Constants.ALLOW_NEFT_PAYMENT;
  public ALLOW_UPI_PAYMENT = Constants.ALLOW_UPI_PAYMENT;
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public isPartial;
  public redeemableCredits: any;
  public listOffers: any;
  public showESignIframe: boolean = false;
  public esignResp: any;
  public esignUrl: any;
  public url: any;
  urlSafe: SafeResourceUrl;
  public signatureMode = EsignMode.activeEsignMode;
  public consumerDetail: any;
  public refreshQuotationCount: number = 0;
  public creditPointApplied: boolean = false;
  public promoCodeApplied: boolean = false;
  public progressWidth: any;
  public progressWidthInPercentage: number = 0;
  public clockDisplay: string;
  public updateProfileModel = new UpdateProfileModel();
  public isTimer = true;
  public interval;
  public defaultTimerLimitInSec = 300;
  public duration: any;
  public seconds = "00";
  public minutes = "00";
  lrsForm: FormGroup;
  localLRSArray: Array<{
    transactionDate: string;
    lrsDeclarationAmount: string;
    institudeName: string;
  }> = [];
  public lrsDeclarationAmount: any;
  public showLocalTransactionDetails: boolean = false;
  public dateOfTransaction: any;
  public selectedDateOfTransaction: any;
  public showLRSForm: boolean = false;
  public showTransactionDetails: boolean = false;
  public transactionList: any;
  public selectedOption: string;
  public lrsDeclarationRequestModel: LRSDeclarationRequestModel =
    new LRSDeclarationRequestModel();
  public maxLRSDate: any;
  public minLRSDate: any;
  public isLRSformSubmit: boolean = false;
  public isLRSSave: boolean = false;
  public referredStatus: any = false;
  orderId: any;
  public referralCode: any = "";
  public referralCodeApplied: boolean = false;

  public isPromoCodeAdded: boolean = false;
  @ViewChild("refPromoCodeList") refPromoCodeList: NgSelectComponent;
  public addressPattern = InputPatterns.ADDRESS_PATTERN;
  public addressPatternOnInput = InputPatterns.ADDRESS_PATTERN_ONINPUT;
  public documentListForPayment;
  public isCheckedForDoument;
  public isBookAndPayTermsAndCond;
  public isRateTimerVisible: boolean = true;  

  private historyState: any = { trapped: true }; // To keep the history entry
  private popstateEventListener: any;
	@ViewChild('backButtonRestricationModal') backButtonRestricationModal: TemplateRef<any>;    
  public showDocumentBackButton:boolean = false;  

  public NBPaymentHtml: string = "";
  public NBPaymentInProcees: boolean = false;
  public paymentProcessInProgress: boolean = false;
   showPopup = false;
    stars = [1, 2, 3, 4, 5];
  selectedRating = 0;
    currentImage = '/assets/images/ad1/experience.gif';
  currentText = 'How was your experience?';
  secondaryText = '';
  userReview = '';
   showPopup1 = false;


  @ViewChild("AD1DocumentDecalrationModal") AD1DocumentDecalrationModal: TemplateRef<any>;
  @ViewChild("rateUsModal") rateUsModal: TemplateRef<any>;

  public requestOrderFeedbackModel: RequestOrderFeedbackModel = new RequestOrderFeedbackModel();

  public confirmDocs: boolean = false;
  public agreeTerms: boolean = false;
  public isReviewSubmitClick: boolean = false;
  public isAllDocumentUplaoded: boolean = false;

  public isAD1Flow: string = "AD2";


  constructor(
    private router: Router,
    public masterDataService: MasterDataService,
    public remittanceService: RemittanceService,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    public updateProfileService: UpdateProfileService,
    public relationshipService: RelationshipService,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public cardService: CardService,
    public gtmPushService: GTMDataLayerService,
    public orderService: OrderService
  ) {


    let configData:any = localStorage.getItem(ConstantsKey.CONFIG_CORE_DATA);
    if(configData) {
      configData = JSON.parse(configData);
      configData = configData.filter(data => data.key == 'flow_family_maintenance');
      if(configData.length == 1) {
        this.isAD1Flow = (configData)[0].value;
        sessionStorage.setItem(ConstantsKey.IS_AD1_FLOW, this.isAD1Flow);
      } else {
        sessionStorage.setItem(ConstantsKey.IS_AD1_FLOW, "AD2");
      }
    }    

    this.getSessionData();
    this.reqCurrencyAmount =
      this.quotationRequest.quotationCurrencies[0].currencyAmount;
    this.timer();
    this.lrsForm = this.fb.group({
      instituteName: ["", Validators.required],
      lrsDeclarationAmount: ["", Validators.required],
      selectedDateOfTransaction: ["", Validators.required],
    });
    this.maxLRSDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    };
    //this.minLRSDate = { year: new Date().getFullYear(), month: 4, day: 1 };
    if (this.maxLRSDate.month > 3) {
      this.minLRSDate = { year: new Date().getFullYear(), month: 4, day: 1 };
    } else {
      let year = new Date().getFullYear() - 1;
      this.minLRSDate = { year: year, month: 4, day: 1 };
    }
  }

  ngOnInit() {


    /* let paymentProcessInProgress = false;
    window.addEventListener('pageshow', (event) => {
      console.log("================================================================================= REMITANCE");
      let orderProcessStatus = localStorage.getItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE);
      if (orderProcessStatus && orderProcessStatus == "IN_PROCESS") {
        //window.location.reload(); //clean and reliable
        let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
        orderData = JSON.parse(orderData);
        let remittanceOrderId = orderData["ORDER_ID"];
        localStorage.removeItem(ConstantsKey.IS_LOUNGE_ORDER_DONE);
        this.router.navigate(["/order-details/", remittanceOrderId]);
        paymentProcessInProgress = true;
      }
    });
     */

        let paymentProcessInProgress = false;
        let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
        localStorage.removeItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE);
        /* if(orderData) {
          orderData = JSON.parse(orderData);
          let remittanceOrderId = orderData["ORDER_ID"];
          let isOrderInProgress = localStorage.getItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE);

          if(isOrderInProgress && isOrderInProgress == "IN_PROCESS") {
            paymentProcessInProgress = true;
            localStorage.removeItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE);
            this.router.navigate(["/order-details/", remittanceOrderId]);
          }
        } */        

  /* if(paymentProcessInProgress == false) { */
      this.horizontalWizardStepper = new Stepper(
        document.querySelector("#stepper1"),
        {}
      );
      this.route.queryParams.subscribe(params => {
        console.log('params_+_', params);
        this.orderId = params.orderId;
        if (this.orderId) {
          this.isRateTimerVisible = false;

          this.showDocumentBackButton = false;
          window.history.pushState(this.historyState, '', window.location.href);
          // Step 2: Intercept back navigation using the popstate event
          this.popstateEventListener = this.onPopState;
          // Add listener for popstate event
          window.addEventListener('popstate', this.popstateEventListener);

          if(this.interval) {
            clearInterval(this.interval);
          }          
          setTimeout(() => {
            this.horizontalWizardStepper.to(4);
          }, 0);
          this.getOrderDocumentList();
        }
        console.log("_+_++__+_+_", this.orderId);
      })
      this.getMenuItemFromConfig();
      this.getCountryList();
      this.getBankAccountList();
      this.getRedeemableCredits();
      this.getProfileDetails();
      this.getRelationshipList();
      this.getCurrencies();
      this.getOffers();
      this.getReferredStatus();
    
      this.contentHeader = this.selectedPurpose.title;
    /* } */
  }

  timer() {
    let seconds: number = Constants.timerValue;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = seconds < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.progressWidth = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      this.progressWidthInPercentage = (seconds / Constants.timerValue) * 100;
      if (seconds == 0) {
        console.log("finished");
        clearInterval(timer);
        this.timer();
        // this.callQuotation();
      }
    }, 1000);
  }

  startTimer() {
    if (this.duration > 0) {
      this.interval = setInterval(() => {
        this.duration = this.duration - 1;
        localStorage.setItem("clockDisplayPer", JSON.stringify(this.duration));

        if (this.duration <= 0) {
          this.hitGetQuotationCall();
        }

        if (this.duration % 60 < 10) this.seconds = "0" + (this.duration % 60);
        else this.seconds = (this.duration % 60).toString();

        if (this.duration / 60 < 10) {
          this.minutes = "0" + parseInt("" + this.duration / 60, 10);
        } else {
          this.minutes = "" + parseInt((this.duration / 60).toString(), 10);
        }
        // this.clockDisplayPer = (this.defaultTimerLimitInSec - this.duration) / 3;
        this.clockDisplay =
          this.minutes +
          " " +
          "minutes" +
          " : " +
          this.seconds +
          " " +
          "seconds";
      }, 1000);
    }
  }

  async getProfileDetails() {
    this.showLoader = true;
    var resp = await this.updateProfileService.getProfileListAll().toPromise();
    this.showLoader = false;
    this.consumerDetail = resp.body;
    if (
      this.consumerDetail?.paxResponse != null &&
      this.consumerDetail?.paxResponse?.address
    ) {
      this.isAddress = true;
    } else {
      this.isAddress = false;
    }

    return true;
  }
  updateProfileAddress() {
    this.showLoader = true;

    console.log("address model>>>> ", JSON.stringify(this.updateProfileModel));
    this.updateProfileService
      .updateProfileDetails(
        this.consumerDetail.paxResponse.id,
        this.updateProfileModel
      )
      .subscribe(
        async (resp) => {
          this.showLoader = false;
          this.navigateToFourthStep = true;
          this.step03GetDocumentProceed(this.kycForm);
        },
        (error) => {
          this.showLoader = false;
          if (error.status == 200) {
            this.navigateToFourthStep = true;
            this.step03GetDocumentProceed(this.kycForm);
          } else {
            this.toast.error("Something went wrong ! Please try again !");
          }
        }
      );
  }

  getCurrencies() {
    this.reqGetCurrencyMaster.cartType = this.selectedPurpose.remittanceType;
    this.reqGetCurrencyMaster.countryCode = "US";
    this.reqGetCurrencyMaster.issuer = "";
    this.reqGetCurrencyMaster.partnerId = Constants.partnerId;
    this.reqGetCurrencyMaster.product = Constants.productsEnum[2];

    this.masterDataService
      .getCurrenciesList(this.reqGetCurrencyMaster)
      .subscribe((result) => {
        this.currencyItems = result.body;
        console.log("curency items >>", this.currencyItems);
        if (this.inrAmountZero) {
        }
      });
  }
  parentCallbackReceiverForListBeneficiary($event) {
    if ($event == "REFRESH_DATA") {
      this.getSessionData();
      this.selectedCountry =
        this.stepperDataModel.step01Data.beneficiary.countryCode;
      this.selectedUniversity =
        this.stepperDataModel.step01Data.beneficiary.viaAgentName;
    }

    if ($event == "REFRESH_DATA_UPDATE_QUOTATION") {
      this.getSessionData();
      this.hitGetQuotationCall();
    }
  }

  parentCallbackForRelationship($event) {
    if ($event == "RELATIONSHIP_DATA_ADDED") {
      this.getSessionData();
      this.getQuotationRequestBody();
    }
  }

  parentCallbackForAddBankAccountForm($event) {
    if ($event == "ADD_BANK_ACCOUNT_ADDED") {
      this.showAddBankForm = false;
      this.getBankAccountList();
    }
  }
  openModalForEditCart() {
    // this.modalReference.close();
    this.modalReference = this.modalService.open(this.EditCardModal, {
      centered: true,
      size: "sm",
    });
  }

  getSessionData() {
    var getActiveOrderData = sessionStorage.getItem(
      ConstantsKey.SS_ACTIVE_ORDER
    );
    if (getActiveOrderData) {
      this.stepperDataModel = JSON.parse(getActiveOrderData);
      this.selectedPurpose = this.stepperDataModel.purposeItem;
      this.quotationRequest = this.stepperDataModel.quotationRequest;
      this.quotationResponse = this.stepperDataModel.quotationResponse;
    }
  }

  getCountryList() {
    this.masterDataService.getCountryList().subscribe((resp) => {
      this.countryListItems = resp.body;
    });
  }

  getUniversityList(selectedCountry) {
    this.showLoader = true;
    this.universityListItems = [];
    this.masterDataService
      .getUniversityList(this.selectedPurpose.remittanceType, selectedCountry)
      .subscribe((resp) => {
        this.universityListItems = JSON.parse(JSON.stringify(resp.body));
        var universityListItemsLocal = JSON.parse(JSON.stringify(resp.body));
        universityListItemsLocal.forEach((universitySingleItems, index) => {
          universitySingleItems["name"] = this.toTitleCase(
            universitySingleItems.name
          );
          this.universityListItems[index] = universitySingleItems;
        });
        this.showLoader = false;
      });
  }

  gotoDashboard() {
    this.router.navigate(["/new-dashboard"]).then(() => {
      window.location.reload();
    });
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  addNewUniversity = (beneficiaryName: string) => {
    this.navigateToAddBeneficiary(beneficiaryName, this.selectedCountry);
  };

  navigateToAddBeneficiary(beneficiaryName, countryCode) {
    var sharedQueryParams = this.selectedPurpose;
    sharedQueryParams["sourcePage"] = PagesList.REMITTANCE_STEPPER;
    sharedQueryParams["beneficiaryName"] = beneficiaryName;
    sharedQueryParams["countryCode"] = countryCode;

    this.router.navigate(["/add-beneficiary"], {
      skipLocationChange: false,
      queryParams: sharedQueryParams,
    });
  }

  getLoanProviderList() {
    this.remittanceService.getLoanProviderList().subscribe((resp) => {
      this.financialInstitutionItem = resp.body;
    });
  }

  getBankAccountList() {
    this.remittanceService.getBankAccountList().subscribe((resp) => {
      this.bankAccountList = resp.body;
    });
  }

  getSelectedSourceFund(selectedItem) {
    if (selectedItem == "Loan") {
      this.showFinancialOptions = true;
      this.getLoanProviderList();
    } else {
      this.showFinancialOptions = false;
    }
  }

  horizontalWizardStepperNext(data) {
    if (data.form.valid === true) {
      this.horizontalWizardStepper.next();
    }
  }

  step01CreateCartItems() {
    var getActiveOrderData = sessionStorage.getItem(
      ConstantsKey.SS_ACTIVE_ORDER
    );
    if (getActiveOrderData) {
      this.stepperDataModel = JSON.parse(getActiveOrderData);
      if (this.stepperDataModel?.step01Data?.beneficiary) {
        this.showLoader = true;
        this.currentStep = "BENEFICIARY_STEP1";
        this.getSessionData();

        let cartItemModel: CartItemModel = new CartItemModel();
        cartItemModel.currencyAmount =
          this.quotationResponse.quotationCurrencyResponses[0].currencyAmount;
        cartItemModel.bidRate =
          this.quotationResponse.quotationCurrencyResponses[0].rate;
        cartItemModel.purpose =
          this.quotationResponse.quotationCurrencyResponses[0].purpose;
        cartItemModel.currencyCode =
          this.quotationResponse.quotationCurrencyResponses[0].currencyCode;
        cartItemModel.product = "REMITTANCE";
        if((this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" || this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == 'AD1') {
          cartItemModel.nostroChargeType = "BENEFICIARY";
        } else {
          cartItemModel.nostroChargeType = "REMITTER";
        }
        cartItemModel.branchId = Constants.wsflReferenceBranchId;
        cartItemModel.sellType = Constants.sellTypes[0];

        cartItemModel.countryCode = this.selectedCountry =
          this.stepperDataModel.step01Data.beneficiary.countryCode;
        cartItemModel.beneficiaryName = this.selectedUniversity =
          this.stepperDataModel.step01Data.beneficiary.viaAgentName;
        cartItemModel.issuerCode = "HOTTISSUER";
        let cartItemMapRequestList = [cartItemModel];

        ///cart item port
        this.remittanceService.cartItemPost(cartItemMapRequestList).subscribe(
          (resp) => {
            let requestMapBeneficiaryModel: RequestMapBeneficiaryModel =
              new RequestMapBeneficiaryModel();
            requestMapBeneficiaryModel.beneficiaryId =
              this.stepperDataModel.step01Data.beneficiary.id;

            ///map beneficiary
            this.remittanceService
              .mapBeneficiary(requestMapBeneficiaryModel)
              .subscribe(
                async (respMapBeneficiary) => {
                  ///refresh quotation
                  this.getQuotationRequestBody();
                  await this.hitGetQuotationCall();
                  await this.updateStepNo(1);
                  await this.mapPayerToCart();
                  this.getDocumentsListForPayment();

                 // await this.getDocumentList();
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
                  this.showLoader = false;

                  /* let eventObj = {
                    name: "web_personal_remittance_step1",
                    event: "web_personal_remittance_step1",
                    number: this.consumerDetail.mobile,
                    remittancepurpose: cartItemModel.currencyAmount,
                    amount: cartItemModel.currencyCode,
                    remittancecountry: cartItemModel.countryCode,
                    purpose: cartItemModel.purpose,
                  };

                  this.gamoogaEvent(eventObj); */
                  this.horizontalWizardStepper.next(); // move to step 2
                },
                (error) => {
                  this.showLoader = false;
                  this.toast.error(error.error.message);
                }
              );
          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
      } else {
        this.toast.error("Please select beneficiary");
      }
    }
  }

  async step02StudentDetails(data) {
    var getActiveOrderData = sessionStorage.getItem(
      ConstantsKey.SS_ACTIVE_ORDER
    );
    if (getActiveOrderData) {
      this.stepperDataModel = JSON.parse(getActiveOrderData);
      if (this.stepperDataModel?.step02Data?.selfResPaxItemSingle) {
        this.showLoader = true;
        if (data.form.valid === true) {
          this.currentStep = "STUDENT_STEP2";
          this.getSessionData();
          this.getQuotationRequestBody();
          await this.hitGetQuotationCall();
          await this.updateStepNo(2);
          await this.mapPayerToCart();
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          this.showLoader = false;
          this.horizontalWizardStepper.next();
        } else {
          this.showLoader = false;
        }
      } else {
        this.toast.error("Please select relation");
      }
    }
  }

  async step03GetDocumentProceed(data) {
    this.showLoader = true;
    if (data.form.valid === true) {
      if (this.isAllDocumentUplaoded) { //this.navigateToFourthStep && 

        this.currentStep = "DOCUMENT_STEP03_1";
        this.getSessionData();
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        await this.getDocumentForSign();
      //  await this.updateStepNo(4);
      
        this.horizontalWizardStepper.next();
      
      }else {
        this.toast.error('Please upload all mandatory documents.');
      }
    }
  }

  async step03EsignOrOtpValidate() {
    if (this.signatureMode == "AADHAR_ESIGN") {
      this.aadharEsignDocumentDetails();
    } else {
      this.otpVerification();
    }
  }

  otpVerification() {
    this.getSessionData();
    var getActiveOrderData = sessionStorage.getItem(
      ConstantsKey.SS_ACTIVE_ORDER
    );
    if (getActiveOrderData) {
      this.stepperDataModel = JSON.parse(getActiveOrderData);
      if (this.stepperDataModel?.step03Data?.checkboxChecked == true) {
        if (
          this.stepperDataModel?.step03Data?.otpValue != null &&
          this.stepperDataModel?.step03Data?.otpValue != ""
        ) {
          this.showLoader = true;
          ///TODO:: Please fix this for production

          this.showLoader = true;
          let a2AcceptanceRequest = {
            otp: this.stepperDataModel?.step03Data?.otpValue,
          };

          //TODO:: Please fix this for production

          // let otpValue
          this.remittanceService.getA2FormCart(a2AcceptanceRequest).subscribe(
            (respDownloadA2) => {
              this.showLoader = false;
              var jsonResult = JSON.parse(JSON.stringify(respDownloadA2.body));
              if (jsonResult.cartDetails.a2FormUrl) {
                let a2FormUrl = jsonResult.cartDetails.a2FormUrl;
                window.open(a2FormUrl, "_blank");
              }
              window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
              this.updateStepNo(4);
              this.horizontalWizardStepper.next();
            },
            (error) => {
              this.showLoader = false;
              this.toast.error(error.error.message);
            }
          );
        } else {
          this.toast.error("Please enter OTP");
        }
      } else {
        this.toast.error("Please accept declaration");
      }
    } else {
      this.router.navigate(["/home"]).then(() => {
        window.location.reload();
      });
    }
  }

  async getDocumentForSign() {
    this.showLoader = true;
    let requestAadhaarEsignDetail = new RequestAadhaarEsignDetailOrder();
       requestAadhaarEsignDetail.orderId = this.orderId;
       requestAadhaarEsignDetail.initiateAadharSigning = true;


     try {
            const respEsign = await this.remittanceService
      .getAadharSignedDoc(requestAadhaarEsignDetail)
      .toPromise();
        this.esignResp = JSON.parse(JSON.stringify(respEsign.body));
        this.esignUrl = this.esignResp.url;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.esignUrl);
        this.showLoader = false;
      } catch (error) {
          this.showLoader = false;
      }
  }

  async aadharEsignDocumentDetails() {
    let requestAadhaarEsignDetail = new RequestAadhaarEsignDetail();
    requestAadhaarEsignDetail.consumerId = localStorage.getItem(
      ConstantsKey.CONSUMER_ID
    );
    requestAadhaarEsignDetail.refOrderId =
    this.orderId;

    this.remittanceService
      .getA2FormSignedDoc(requestAadhaarEsignDetail)
      .subscribe(async (resp) => {
        var resAadhaarEsignDetail = JSON.parse(JSON.stringify(resp.body));
        if (resp.status == 200) {
          if (
            resAadhaarEsignDetail.esignFileUrl &&
            resAadhaarEsignDetail.esignFileUrl != null &&
            resAadhaarEsignDetail.esignFileUrl != ""
          ) {
            // await this.updateStepNo(4);
            // window.scroll({
            //   top: 0,
            //   left: 0,
            //   behavior: "smooth",
            // });

            this.showLoader = false;
            this.modalReference = this.modalService.open(this.rateUsModal, { centered: true, backdrop: 'static' } );
            // this.router.navigate(['/ratings', this.orderId]);

          } else {
            this.toast.error("Please esign document properly.");
          }
        } else {
          this.toast.error("Please esign document properly!");
        }
      });
  }

  async getRelationshipList() {
    var respRelationShip = await this.relationshipService
      .getRelationshipList()
      .toPromise();
    var relationshipMemberListItems: Array<any> = JSON.parse(
      JSON.stringify(respRelationShip.body)
    );
    if (relationshipMemberListItems.length > 0) {
      relationshipMemberListItems.forEach((singlePaxItem) => {
        if (singlePaxItem.relationship.toLowerCase() == "self") {
          if (singlePaxItem.pan != null && singlePaxItem.pan.length == 10) {
            let step02Data = new Step02Data();
            step02Data.selfResPaxItemSingle = singlePaxItem;
            this.stepperDataModel.step02Data = step02Data;
            sessionStorage.setItem(
              ConstantsKey.SS_ACTIVE_ORDER,
              JSON.stringify(this.stepperDataModel)
            );
          }
        }
      });
    }
  }

  async hitGetQuotationCall() {
    if (this.stepperDataModel.quotationResponse != null) {
      this.requestQuotationModel.quotationSnapshotId =
        this.stepperDataModel.quotationResponse.quotationSnapshotId;
    }
    //var respQuotation = await this.remittanceService.getQuotation(this.requestQuotationModel).toPromise();
    this.showLoader = true;
    return new Promise((resolve, reject) => {
      this.remittanceService
        .getQuotationEncrypted(this.requestQuotationModel)
        .subscribe(
          (resp) => {},
          (error) => {
            this.showLoader = false;
            if (error.status == 200) {
              this.stepperDataModel.quotationResponse = JSON.parse(
                this.cryptoUtils.resDecrypt(error.error.text)
              );
              this.stepperDataModel.quotationRequest =
                this.requestQuotationModel;
              sessionStorage.setItem(
                ConstantsKey.SS_ACTIVE_ORDER,
                JSON.stringify(this.stepperDataModel)
              );
              this.refreshQuotationCount = this.refreshQuotationCount + 1;
              this.getSessionData();
              resolve("success");
            } else {
              this.toast.error(error.error.message);
              reject("fail");
            }
          }
        );
    });
  }

  async updateStepNo(stepNo: number) {
    const response = await this.remittanceService
      .getCartToUpdateStepNumber(stepNo)
      .toPromise();
    this.activeCartModelStep = response.body;

    //[start] update session data
    this.getSessionData();
    var getActiveOrderData = sessionStorage.getItem(
      ConstantsKey.SS_ACTIVE_ORDER
    );
    // if (getActiveOrderData) {
    //   this.stepperDataModel = JSON.parse(getActiveOrderData);
    //   this.stepperDataModel.cartItemsResponse = this.activeCartModelStep;
    //   if (
    //     this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" ||
    //     this.selectedPurpose.purposeCode === "GIFT"
    //   ) {
    //     this.paymentMode = "MANUAL";
    //   }
    // }
    sessionStorage.setItem(
      ConstantsKey.SS_ACTIVE_ORDER,
      JSON.stringify(this.stepperDataModel)
    );
    //[end] update session data

    this.showLoader = false;
    return response;
  }

  horizontalWizardStepperPrevious() {
    console.log("this.currentStep ------------- ", this.currentStep, this.horizontalWizardStepper);
    if(this.horizontalWizardStepper["_currentIndex"] == 1){
      this.horizontalWizardStepper.to(1);
    } else {
      if ((this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" || this.selectedPurpose.purposeCode === "GIFT") || this.isAD1Flow == 'AD1') {
        if(this.horizontalWizardStepper["_currentIndex"] == 2) {
          this.horizontalWizardStepper.to(2);
        }   
      } else {
        this.horizontalWizardStepper.previous();
      }
    }


  }

  openModalForPaymentInfo(paymentInstructionModal, bookAndPayInstructionModal) {
    this.hitGetQuotationCall();
    sessionStorage.setItem(ConstantsKey.IS_FROM_REMITTANCE_FLOW, "true");
    sessionStorage.setItem(ConstantsKey.IS_FROM_RELOAD, "false");
    sessionStorage.setItem(ConstantsKey.IS_FROM_BUYNEWCARD, "false");
    if (
      this.isPartial ||
      (this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" ||
      this.selectedPurpose.purposeCode === "GIFT") || this.isAD1Flow == "AD1"
    ) {
      if (this.paymentMode) {
        if (
          this.paymentMode == "MANUAL" ||
          (this.paymentMode == "NB" && this.bankAccountId) || (this.paymentMode == "UPI" && this.bankAccountId)
        ) {
          /* this.modalReference = this.modalService.open(
            paymentInstructionModal,
            { centered: true }
          ); */
          if (this.paymentMode == PaymentMode?.NET_BANKING || this.paymentMode == PaymentMode?.UPI) {
            this.paymentInstruction =
              "";
          } else if (
            this.paymentMode == PaymentMode?.NEFT_RTGS ||
            this.paymentMode == PaymentMode?.TPV
          ) {
            this.paymentInstruction =
              "If you choose to proceed with this mode of payment, we request you to upload the payment proof under the Order Details section in My Orders for timely processing.";
          }

              if((this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" || this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == "AD1") {
                this.step04Payment();
              } else {
                if(this.isPartial == 'true') {
                  this.modalReference = this.modalService.open(bookAndPayInstructionModal, { centered: true } );
                } else {
                  this.modalReference = this.modalService.open(paymentInstructionModal, { centered: true } );
                }
              }


            let stepperData = this.stepperDataModel;
            let evtObj = {
              "event": "personal-remittance-order",
              "mobile": "91"+this.consumerDetail.mobile,
              "currency": stepperData?.quotationRequest?.quotationCurrencies[0]?.currencyCode,
              "currencyamount": stepperData?.quotationRequest?.quotationCurrencies[0]?.currencyAmount,
              "remittancepurpose": this.stepperDataModel?.purposeItem?.title,
              "beneficiaryname": stepperData?.step01Data?.beneficiary?.name
            };

            this.gamoogaEvent(evtObj);          

        } else {
          if (this.bankAccountList.length == 0) {
            this.toast.error("Kindly add a new Bank Account");
          } else {
            this.toast.error("Please select your bank account.");
          }
        }
      } else {
        this.toast.error("Please select your payment method.");
      }
    } else {
      this.toast.error("Please select payment type.");
    }
  }

  step04Payment() {
    if((this.isCheckedForDoument || this.isAD1Flow == '') || ((this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" || this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == 'AD1')) {
    var paymentMode = this.paymentMode;
    this.modalReference.close();
    this.showLoader = true;
    this.remittanceService
      .cartPlaceOrder(this.bankAccountId, paymentMode)
      .subscribe(
        (respPayment) => {
          var respPaymentBody = JSON.parse(JSON.stringify(respPayment.body));
          this.showLoader = false;

          /* let gtmEventObj = {
            event: "web_personal_remittance_payment",
            name: "web_personal_remittance_payment",
            "payment-mode": paymentMode,
            number: this.consumerDetail.mobile,
          };
          this.gamoogaEvent(gtmEventObj); */

          /* if (paymentMode == PaymentMode.NET_BANKING) {
            sessionStorage.setItem('Navigate_Back_to_stepper3', 'true');

            this.getPaymentGatewayLink(respPaymentBody.orderId);
          } else */ 

          let orderType = { "ORDER_TYPE" : "PERSONAL_REMITTANCE", "ORDER_ID": respPaymentBody.orderId };
          localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));
          localStorage.setItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE, "IN_PROCESS");    

          if(paymentMode == PaymentMode.UPI || paymentMode == PaymentMode.NET_BANKING) {
            this.getUPIPaymentLink(respPaymentBody.orderId)
            sessionStorage.setItem('Navigate_Back_to_stepper3', 'true');
          } else {

            let orderType = { "ORDER_TYPE" : "PERSONAL_REMITTANCE", "ORDER_ID": respPaymentBody.orderId };
            localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));
            localStorage.setItem(ConstantsKey.IS_PERS_REMITTANCE_ORDER_DONE, "IN_PROCESS");                  

            sessionStorage.setItem('Navigate_Back_to_stepper3', 'true');
            this.router.navigate(["/payment-success", respPaymentBody.orderId]);
          }
        },
        (error) => {
          this.showLoader = false;
          this.toast.error(error.error.message);
        }
      );
    } else {
      this.toast.error("You must confirm that you have all the listed documents before proceeding.");
    }
  }

  async mapPayerToCart() {
    this.getSessionData();
    let requestCartMapPayer = new RequestCartMapPayer();

    requestCartMapPayer.remitterType = this.selectedPurpose.remittanceType;
    // requestCartMapPayer.remitterType = "OTHER";
    requestCartMapPayer.payerName =
      this.stepperDataModel.step02Data.selfResPaxItemSingle.name;
    requestCartMapPayer.payerPan =
      this.stepperDataModel.step02Data.selfResPaxItemSingle.pan;

    requestCartMapPayer.travellerPaxId =
      this.stepperDataModel.step02Data.selfResPaxItemSingle.id;
    if (this.selectedPurpose.remittanceType != "OTHERS") {
      requestCartMapPayer.travellerPaxId =
        this.stepperDataModel.step02Data.selfResPaxItemSingle.id;
    }

    requestCartMapPayer.payerName =
      this.stepperDataModel.step02Data.selfResPaxItemSingle.name;
    requestCartMapPayer.payerPaxId =
      this.stepperDataModel.step02Data.selfResPaxItemSingle.id;

    // Map requestCartMapPayerJson = requestCartMapPayer.toJson();
    if (this.selectedPurpose.remittanceType == "OTHERS") {
      // requestCartMapPayer.remove('paidBy');
      // requestCartMapPayer.remove('paxId');
    }

    await this.remittanceService.cartPayerMap(requestCartMapPayer).toPromise();
  }
  async updateCurrencyAmount() {
    if (this.reqCurrencyAmount && this.reqCurrencyAmount != "") {
      this.showLoader = true;
      this.modalReference.close();
      //this.inrAmountZero = false;
      // this.getSessionData();
      this.quotationRequest.quotationCurrencies[0].currencyAmount =
        this.reqCurrencyAmount;
      this.getQuotationRequestBody();
      await this.hitGetQuotationCall();
      // this.getSessionData();
      this.refreshQuotationCount = this.refreshQuotationCount + 1;
      console.log("refreshQuotationCount >>", this.refreshQuotationCount);

      this.showLoader = false;
    }
  }
  parentCallbackForFooter($event) {
    console.log("$event >>", $event);

    if ($event == "UPDATE_QUOTATION") {
      this.getSessionData();
      this.hitGetQuotationCall();
    }
  }

  getQuotationRequestBody() {
    this.requestQuotationModel = this.quotationRequest;

    if (this.currentStep == "STUDENT_STEP2") {
      this.requestQuotationModel.pan =
        this.stepperDataModel.step02Data.selfResPaxItemSingle.pan;
      this.requestQuotationModel.tcsPaymentSource =
        this.selectedSourceofFund.toUpperCase();
      if (this.selectedSourceofFund == "Loan") {
        this.requestQuotationModel.tcsPaymentSourceDetails =
          this.selectedInstitution != "Other"
            ? this.selectedInstitution
            : this.instituteName;
      } else {
        this.requestQuotationModel.tcsPaymentSourceDetails = "";
      }
      this.requestQuotationModel.paymentSourceDetails =
        this.selectedSourceofFund;
      this.requestQuotationModel.taxResidentOfIndia = true;
      // this.requestQuotationModel.otherSourcePaymentDetails = '';
    }

    if (
      this.stepperDataModel.purposeItem.remittanceType == "OTHERS" &&
      this.stepperDataModel?.step02Data?.selfResPaxItemSingle?.pan != null
    ) {
      this.requestQuotationModel.calculateTcs = true;
      this.requestQuotationModel.tcsPaymentSource = "OWN";
      this.requestQuotationModel.taxResidentOfIndia = true;
      this.requestQuotationModel.pan =
        this.stepperDataModel.step02Data.selfResPaxItemSingle.pan;
      this.requestQuotationModel.paymentSourceDetails = "";
    }
  }
  fileUploadOrderDocument(event, docType) {
    this.showLoader = true;
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      console.log("File >>>");
      console.log(file);
      console.log("file type++", file.type);
      if (file.type.indexOf("pdf") >= 0 || file.type.indexOf("image") >= 0) {
        const formData = new FormData();
        formData.append("file", file, file.name);
        formData.append("ownerType", "CONSUMER");
        formData.append("type", docType);
        formData.append("description", "");
        formData.append(
          "ownerId",
          localStorage.getItem(ConstantsKey.CONSUMER_ID)
        );
        formData.append("documentPurpose", "TRANSACTION");

        // if (file.size > 1000000) {
        //   this.showLoader = false;
        //   this.toast.error('Please upload a file of up to 1MB only');
        // } else {
        this.remittanceService.uploadOrderDocument(formData).subscribe(
          (respDoc) => {
            this.showLoader = false;

            let resp = respDoc.body;
            let documentIds = [resp["id"]];
            let linkDocumentData = {
                "documentIds": documentIds,
                "kycDocumentPurpose": "TRANSACTION"
            };

            this.cardService.linkDocument(linkDocumentData, this.orderId).subscribe(resp => {

            }, err => {
              this.showLoader = false;
              if (err.status == 200) {
                this.toast.success("Document uploaded successfully");

                this.getOrderDocumentList();
      
              } else {
                this.toast.error(err.error.message);
              }
            });
          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
      } else {
        this.showLoader = false;
        this.toast.error('Please select a pdf or image file only');
      }
      if (file.type == "application/pdf") {
        this.isPdf = true;
      }
      // if(file.type == 'image/png') {
      //   this.isPdf = false;
      // }
      // console.log("this.ispdf", this.isPdf);
      // console.log("this.isImage", this.isImage)
    }
  }

  fileUploadCartDocument(event, docType) {
    this.showLoader = true;
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      console.log("File >>>");
      console.log(file);
      console.log("file type++", file.type);
      if (file.type.indexOf("pdf") >= 0 || file.type.indexOf("image") >= 0) {
        const formData = new FormData();
        formData.append("file", file, file.name);
        formData.append("ownerType", "CONSUMER");
        formData.append("type", docType);
        formData.append("description", "");
        formData.append(
          "ownerId",
          localStorage.getItem(ConstantsKey.CONSUMER_ID)
        );
        formData.append("documentPurpose", "TRANSACTION");

        // if (file.size > 1000000) {
        //   this.showLoader = false;
        //   this.toast.error('Please upload a file of up to 1MB only');
        // } else {
        this.remittanceService.uploadDocument(formData).subscribe(
          (respDoc) => {
            this.showLoader = false;
            if (docType != "LOAN_DOCUMENT") {
              this.getDocumentList();
            }
          },
          (error) => {
            this.showLoader = false;
            this.toast.error(error.error.message);
          }
        );
      } else {
        this.showLoader = false;
        this.toast.error('Please select a pdf or image file only');
      }
      if (file.type == "application/pdf") {
        this.isPdf = true;
      }
      // if(file.type == 'image/png') {
      //   this.isPdf = false;
      // }
      // console.log("this.ispdf", this.isPdf);
      // console.log("this.isImage", this.isImage)
    }
  }

  async getOrderDocumentList() {
    this.remittanceService.getOrderDocuments(this.orderId).subscribe(
      (resp) => {
        this.documentListResponse = resp.body;
        this.transactionDocListAwaiting =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.AWAITING;
        this.transactionDocListUploaded =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.UPLOADED;

        /* if (
          this.documentListResponse.skipDocumentUpload == true &&
          this.isAddress
        ) { */
        let isAlleFileUPloaded = this.transactionDocListAwaiting.filter(obj => obj.required == true);
        if (isAlleFileUPloaded.length == 0) {

          this.navigateToFourthStep = true;
          this.isAllDocumentUplaoded = true;
        }
      },
      (error) => {
        this.toast.error(error.error.message);
      }
    );
  }

  async getDocumentList() {
    this.remittanceService.getDocuments().subscribe(
      (resp) => {
        this.documentListResponse = resp.body;
        this.transactionDocListAwaiting =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.AWAITING;
        this.transactionDocListUploaded =
          this.documentListResponse.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.UPLOADED;

        if (
          this.documentListResponse.skipDocumentUpload == true &&
          this.isAddress
        ) {
          this.navigateToFourthStep = true;
        }
      },
      (error) => {
        this.toast.error(error.error.message);
      }
    );
  }

  showToast() {
    if (
      this.documentListResponse.skipDocumentUpload == true &&
      this.isAddress == false
    ) {
      if (this.updateProfileModel.address != null) {
        this.updateProfileAddress();
      } else {
        this.toast.error("Please Add your Address");
      }
    } else {
      this.toast.error("Please upload mandatory document");
    }
  }

  openModalForTransactionDocumentView(
    transactionDocumentViewModal,
    documentDetails
  ) {
    this.modalReference = this.modalService.open(transactionDocumentViewModal, {
      centered: true,
    });
    this.documentUrl = documentDetails.location;
    this.documentTitle = documentDetails.documentType;
  }

  downloadUploadedDoc(documentDetails) {
    this.documentUrl = documentDetails.location;
    // if(this.isPdf == true) {
    window.location.assign(this.documentUrl);
    // }
    // if(this.isPdf == false) {
    //   window.open(this.documentUrl, '_blank');
    // }
    // console.log("pdf++", this.isPdf)
  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
  }

  getPaymentGatewayLink(orderId: string) {
    this.showLoader = true;

    this.remittanceService
      .getPaymentGatewayLink(orderId, this.isPartial, this.bankAccountId)
      .subscribe(
        (respPaymentLink) => {
          this.showLoader = false;
          var responsePaymentLinkBody = JSON.parse(
            JSON.stringify(respPaymentLink.body)
          );
          window.location.href = responsePaymentLinkBody.payment_link;
        },
        (error) => {
          this.showLoader = false;
          console.log("Error in generating payment link", error);
        }
      );
  }

  setPaymentModeAsFullPayment() {
    this.showNEFT = true;
    this.showNetBanking = true;
  }

  setPaymentMethodAsPartial() {
    this.showNetBanking = true;
    this.showNEFT = false;
    this.paymentMode = undefined;
  }

  getRedeemableCredits() {
    this.remittanceService.getRedeemableCredits().subscribe(
      (resp) => {
        this.redeemableCredits = resp.body;
        console.log("this.redeemableCredits >>", this.redeemableCredits);
      },
      (error) => {
        console.log("Unable to get credit points!", error);
      }
    );
  }

  async applyCreditPointToQuote() {
    if (this.requestQuotationModel.pointsToRedeem) {
      if (
        this.requestQuotationModel.pointsToRedeem >
        this.redeemableCredits?.availableCredit
      ) {
        this.toast.error(
          "Entered Points are more than available credit points"
        );
      } else if (
        this.requestQuotationModel.pointsToRedeem >
        this.redeemableCredits?.availableCredit
      ) {
        this.toast.error(
          "You can redeem maximum upto " +
            this.redeemableCredits?.maximumRedeemableCredit +
            "points!"
        );
      } else {
        await this.hitGetQuotationCall();
        this.getSessionData();
        this.creditPointApplied = true;
        this.toast.success("Credit points applied");
      }
    } else {
      this.toast.error("Please enter redeemdable points !");
    }
  }

  async removeCreditPoint() {
    this.requestQuotationModel.pointsToRedeem = null;
    await this.hitGetQuotationCall();
    this.getSessionData();
    this.creditPointApplied = false;
    this.toast.success("Credit points removed");
  }

  getOffers() {
    this.listOffers = [];
    let listOfferLocal = [];
    this.remittanceService.getOffers().subscribe(
      (resp) => {
        var offerListAll = JSON.parse(JSON.stringify(resp.body));
        for (let singleOffer of offerListAll) {
          if (
            singleOffer.status == "ACTIVE" &&
            (singleOffer.scope == "PRIVATE" || singleOffer.scope == "PUBLIC")
          ) {
            listOfferLocal.push(singleOffer);
          }
        }
        console.log("OFFERS >>", this.listOffers);
        this.listOffers = listOfferLocal;
      },
      (error) => {
        this.toast.error(error.error.message);
      }
    );
  }

  async applyPromoCode() {
    if (this.requestQuotationModel.promoCode) {
      this.isPromoCodeAdded = true;
      this.showLoader = true;
      await this.hitGetQuotationCall()
        .then((res) => {
          this.showLoader = false;
          if (res == "success") {
            this.getSessionData();
            this.toast.success("Promocode applied successfully!");
            this.promoCodeApplied = true;
          }
        })
        .catch((err) => {
          this.showLoader = false;
          if (err == "fail") {
            this.refPromoCodeList.handleClearClick();
          }
        });
    } else {
      this.toast.error("Please enter promocode!");
    }
  }

  async removePromoCode() {
    this.requestQuotationModel.promoCode = null;
    await this.hitGetQuotationCall();
    this.getSessionData();
    this.toast.success("Promocode removed successfully!");
    this.promoCodeApplied = false;
  }

  showIframeForEsign() {
    this.getSessionData();
    if (this.stepperDataModel.step03Data) {
      if (!this.stepperDataModel.step03Data.checkboxChecked) {
        this.toast.error("Please accept the terms and conditions to proceed.");
      } else {
        if((this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" || this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == "AD1") {
          // this.router.navigate(['/ratings', this.orderId]);
          this.modalReference = this.modalService.open(this.rateUsModal, { centered: true, backdrop: 'static' } );
        } else {
          this.showESignIframe = true;
        }        
      }
    } else {
      this.toast.error("Please accept the terms and conditions to proceed.");
    }
  }

  public configData: any;
  public showNetBanking: boolean = true;
  public showNEFT: boolean = true;
  public partialPaymentAllowed: boolean = true;

  getMenuItemFromConfig() {
    // let data = sessionStorage.getItem('CONFIG_DATA');
    // this.configData = JSON.parse(data);
    this.configData = {
      remittanceFlowEnable: true,
      personalFlowEnable: true,
      cardFlowEnable: true,
      insuranceEnable: true,
      dashboardEnable: true,
      myAccountMenuEnable: true,
      myAccountSubMenuEnable: true,
      relationshipEnable: true,
      beneficiaryEnable: true,
      bankAccountEnable: true,
      ordersEnable: true,
      pendingOrdersEnable: true,
      rewardsEnable: true,
      offersEnable: true,
      branchNetworkEnable: true,
      currencyConverterEnable: true,
      resetPasswordEnable: true,
      ratesEnable: true,
      setRateAlertEnable: true,
      supportEnable: true,
      addressEnable: true,
      faqEnable: true,
      tutorialEnable: true,
      paymentModeNBEnable: true,
      paymentModeNEFTEnable: true,
      partialPaymentEnable: true,
      openGICAccountEnable: true,
      blockedAccountEnable: true,
      zolveCreditCardEnable: true,
      isicCardEnable: true,
    };

    if (!this.configData.paymentModeNBEnable) {
      this.showNetBanking = false;
    } else if (!this.configData.paymentModeNEFTEnable) {
      this.showNEFT = false;
    } else if (!this.configData.partialPaymentEnable) {
      this.partialPaymentAllowed = false;
    }
  }

  showLRSFormSection(booleanValue) {
    this.showLRSForm = booleanValue;
  }

  saveLRSDataLocally() {
    this.isLRSformSubmit = true;
    if (this.lrsForm.valid) {
      this.lrsDeclarationRequestModel.transactionDate =
        DateUtils.getNgbDateStructToDate(
          this.lrsForm.controls["selectedDateOfTransaction"].value
        );
      const newTransaction = {
        transactionDate: this.lrsDeclarationRequestModel.transactionDate,
        lrsDeclarationAmount:
          this.lrsForm.controls["lrsDeclarationAmount"].value,
        institudeName: this.lrsForm.controls["instituteName"].value,
      };
      this.localLRSArray.push(newTransaction);
      this.lrsForm.reset();
      this.showLRSForm = false;
      if (this.localLRSArray.length > 0) {
        this.showLocalTransactionDetails = true;
      }
    }
  }

  proceedToLRSDeclaration() {
    this.cardService.lrsDeclaration(this.localLRSArray).subscribe((resp) => {
      this.showLoader = false;
      this.consumerDetail = resp.body;
      this.toast.success("LRS Declaration Details saved successfully!");
      this.getAllOrderLrsDetail();
      this.showLocalTransactionDetails = this.showLRSForm = false;
    });
  }

  getAllOrderLrsDetail() {
    this.cardService.getAllOrderLrsDetails().subscribe((resp) => {
      this.transactionList = resp.body;
      console.log(this.transactionList);
      if (this.transactionList.length > 0) {
        this.showTransactionDetails = true;
        this.selectedOption = "Yes";
        this.showLRSFormSection(true);
      }
    });
  }

  removeLRSEntry(index: number) {
    this.localLRSArray.splice(index, 1);
    if (this.localLRSArray.length == 0) {
      this.showLocalTransactionDetails = false;
    }
  }

  async checkLRSStep() {
    if (this.selectedOption) {
      if (this.localLRSArray.length > 0 && !this.isLRSSave) {
        this.showLoader = true;
        this.cardService.lrsDeclaration(this.localLRSArray).subscribe(
          (resp) => {
            this.consumerDetail = resp.body;
            this.showLoader = false;
            this.getAllLRSData();
          },
          (err) => {
            this.showLoader = false;

            console.log(err);
            Swal.fire({
              title: "Dear Customer",
              html: err.error.message,
              imageUrl: "assets/images/icons/info_icon.png",
              imageWidth: 80,
              imageHeight: 80,
              focusConfirm: false,
              confirmButtonColor: "#080808",
            });
          }
        );
      } else {
        if (
          (this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" ||
          this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == "AD1"
        ) {
          this.updateStepNo(4);
          this.modalReference = this.modalService.open(this.AD1DocumentDecalrationModal, { centered: true, backdrop: 'static' } );
        } else {
          this.horizontalWizardStepper.next();
        }
      }
    } else {
      this.toast.error("Please complete LRS Declaration!");
    }
  }
  async getAllLRSData() {
    this.cardService.getAllOrderLrsDetails().subscribe(
      (resp) => {
        this.getDocumentForSign();
        this.transactionList = resp.body;
        this.hitGetQuotationCall();
        this.showLRSForm = false;
        this.isLRSSave = true;
        this.isLRSformSubmit = false;
        if (
          (this.selectedPurpose.purposeCode === "FAMILY_MAINTENANCE" ||
          this.selectedPurpose.purposeCode === "GIFT") && this.isAD1Flow == "AD1"
        ) {
          this.updateStepNo(4);
          this.modalReference = this.modalService.open(this.AD1DocumentDecalrationModal, { centered: true, backdrop: 'static' } );
          // this.horizontalWizardStepper.next();
        } else {
          this.horizontalWizardStepper.next();
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Dear Customer",
          html: err.error.message,
          imageUrl: "assets/images/icons/info_icon.png",
          imageWidth: 80,
          imageHeight: 80,
          focusConfirm: false,
          confirmButtonColor: "#080808",
        });
      }
    );
  }

  closeLRSForm() {
    this.lrsForm.reset();
    this.isLRSformSubmit = false;
    this.showLRSForm = false;
  }

  get lrsFormControl(): any {
    return this.lrsForm["controls"];
  }
  addNewCoupon = (offer) => {
    return { title: offer, promoCodeId: offer };
  };

  getReferredStatus() {
    this.remittanceService.getReferredStatus().subscribe(
      (resp) => {
        this.referredStatus = resp.body;
        console.log("REFERRAL CODE ===== ", this.referralCodeApplied);
      },
      (err) => {}
    );
  }

  applyReferralCode() {
    if (this.referralCode == "") {
      this.toast.error("Please enter Referrer Code!");
    } else {
      this.remittanceService
        .updateConsumerReferrer({}, this.referralCode)
        .subscribe(
          (resp) => {},
          (error) => {
            this.showLoader = false;
            if (error.status == 202) {
              let response = JSON.parse(
                this.cryptoUtils.resDecrypt(error.error.text)
              );
              this.toast.success(response);
              this.referralCodeApplied = true;
            } else {
              this.toast.error(error.error.message);
            }
          }
        );
    }
  }

  /* removeReferralCode() {
    this.referralCode = "";
    this.toast.success("Referral Code Removed!");
    this.referralCodeApplied = false;
  } */


    getDocumentsListForPayment() {
      this.showLoader = true;
      this.cardService
        .cartTotalVersusUploadedDocuments()
        .subscribe((respDocList) => {
          this.showLoader = false;
  
          let documentList: any = respDocList.body;
          let allDocs = documentList.documentCategorywiseUploadDetails.TRANSACTION.statusWiseDocuments.AWAITING;
          this.documentListForPayment = allDocs.filter(e => e.required === true);
        }),
        (error) => {
          this.showLoader = false;
          this.toast.error(error.error.message);
        };
    }
  

  gamoogaEvent(obj) {
    this.gtmPushService.dataLayerPushData(obj);
  }
  keyPressNumbers(event) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  proceedBookAndPayPopup(travelDocumentInstructionModal) {
     if(this.isBookAndPayTermsAndCond) {
      this.modalReference.close();
      this.modalReference = this.modalService.open(travelDocumentInstructionModal, { centered: true } );
     } else {
      this.toast.error("Kindly accept the Terms & conditions");
     }
  }

  getUPIPaymentLink(orderId: string) {
    this.showLoader = true;
    this.getSessionData();
    let requestObj = {
      'paymentType': this.paymentMode,
      'orderId': orderId,
      'bankId': this.bankAccountId,
      'product': 'REMITTANCE',
      'deviceType': 'WEB'
    };

    this.orderService.getPayULink(orderId, requestObj, this.isPartial).subscribe(resp => {
      this.showLoader = false;

  
      var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));

      if(respUPIPayLinkData.status == "SUCCESS") {
        // if(this.paymentMode == "NB") {
        //   this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
        //   document.open();          
        //   document.write(this.NBPaymentHtml);
        //   document.close();
        // } else if(this.paymentMode == "UPI") {
        //   window.location.href = respUPIPayLinkData.redirectionURL;
        // }
        if(respUPIPayLinkData.redirectionURL) {
          window.location.href = respUPIPayLinkData.redirectionURL;
        } else {
          this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          document.open();          
          document.write(this.NBPaymentHtml);
          document.close();
        }
      } else if(respUPIPayLinkData.status == "ERROR") {
        let errMsg:string = respUPIPayLinkData.errorDescription;
        if(errMsg.includes("not support PayU")) {
          this.getPaymentGatewayLink(orderId);
        }
      }
  
      /* var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
      window.location.href = respUPIPayLinkData.redirectionURL; */
    }, error => {
      this.showLoader = false;
      console.log("Error in generating payment link");
    });
  }

  onPopState = (event: PopStateEvent) => {
    // Push the state back to trap the user again
    console.log("TEST");
    window.history.pushState(this.historyState, '', window.location.href);
    this.modalReference = this.modalService.open(this.backButtonRestricationModal, { size: 'sm', centered: true });
  };

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.popstateEventListener);
  }

  closeBackButtonModal() {
    this.modalReference.close();
  }


  openPopup() {
    this.showPopup = true;
  }
 openPopup1() {
    this.showPopup1 = true;
  }
  closePopup1() {
    this.showPopup1 = false;
  }

  rate(rating: number) {
    this.selectedRating = rating;

    if (rating <= 3) {
      this.currentImage = '/assets/images/ad1/hear-you.gif';
      this.currentText = 'We hear you';
      this.secondaryText = 'What could we have done better?';
    } else {
      this.currentImage = '/assets/images/ad1/Excellent.gif';
      this.currentText = 'Excellent!';
      this.secondaryText = 'We’d love to hear about your experience.';
    }
  }

  submitReview() {

    if(this.userReview != "") {
      this.requestOrderFeedbackModel.orderId = this.orderId;
      this.requestOrderFeedbackModel.overall = this.selectedRating.toString();
      this.requestOrderFeedbackModel.comment = this.userReview;
      this.orderService.postOrderRating(this.requestOrderFeedbackModel).subscribe((respOrderRating => {
          this.showLoader = false;
          this.modalReference.close();
          this.router.navigate(['/sit-back-relax', this.orderId]);
      }), error => {
          this.showLoader = false;
          this.modalReference.close();
          this.toast.error(error.error.message);
          this.router.navigate(['/sit-back-relax', this.orderId]);        
      });
    } else {
      this.isReviewSubmitClick = true;
    }


  }

  closePopup() {
    this.showPopup = false;
  }


  proceedAD1Payment() {
    if(!this.confirmDocs) {
      this.toast.error("You must confirm that you have all the listed documents before proceeding!");
      return false;
    } else if(!this.agreeTerms) {
      this.toast.error("Please accept terms and conitions!");
      return false;
    }    
    this.modalReference.close();
    this.horizontalWizardStepper.next();
  }

  goToSitBackAndRelaxPage() {
    this.modalReference.close();
    this.router.navigate(['/sit-back-relax', this.orderId]);    
  }    


}
